import { has, isArray, forEach } from 'lodash';
import API from 'services/API/index';
import { moment } from 'utils';
import sortMessageHistory from '../../utils/sortMessageHistory';
import { DATE_FORMAT, DATE_FORMAT_WITHOUT_TIME } from '../../components/Message/private/constants';

const attributes = {
  appealCategory: 'Категория',
  appealTheme: 'Тема',
  appealText: 'Текст обращения',
};

export default function getMessage(messageId, cardId) {
  const parameters = {
    notificationId: messageId,
    cardId: cardId,
  };

  return API.request({
    method: 'GET',
    url: `/notification/details`,
    params: parameters,
    mapper: function (message = {}) {
      if (has(message, 'history') && isArray(message.history)) {
        message.history = message.history
          .map((history) => {
            history.date = moment.fromServerFullDatetime(history.notificationDateTime);
            return history;
          })
          .sort(sortMessageHistory);
        message.date = message.notificationDateTime
          ? moment.fromServerFullDatetime(message.notificationDateTime)
          : (message.history[0] || {}).date;
      } else {
        message.date = moment.fromServerFullDatetime(message.notificationDateTime);
      }

      message.registrationDateStr = message.registrationDate
        ? message.registrationDate.length === 10
          ? moment.fromServerFullDatetime(message.registrationDate).format(DATE_FORMAT_WITHOUT_TIME)
          : moment.fromServerFullDatetime(message.registrationDate).format(DATE_FORMAT)
        : null;
      message.answerDateStr = message.answerDate
        ? message.answerDate.length === 10
          ? moment.fromServerFullDatetime(message.answerDate).format(DATE_FORMAT_WITHOUT_TIME)
          : moment.fromServerFullDatetime(message.answerDate).format(DATE_FORMAT)
        : null;

      message.registrationDate = message.registrationDate
        ? moment.fromServerFullDatetime(message.registrationDate)
        : null;
      message.answerDate = message.answerDate
        ? moment.fromServerFullDatetime(message.answerDate)
        : null;
      message.additionalAttributes = getAdditionalAttributes(message);

      return message;
    },
  });
}

function getAdditionalAttributes(message) {
  let result = [];

  forEach(attributes, (title, key) => {
    if (message[key]) {
      result.push({
        name: title,
        value: message[key],
      });
    }
  });

  return result;
}
